import React, { useState, createContext, useContext, useEffect } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { getStorage, ref, listAll, uploadBytes, getDownloadURL } from "firebase/storage";


const StorageContext = createContext([])

export const useStorageContext = () => useContext(StorageContext)


const StorageContextProvider = ({ children }) => {


    const db = getFirestore()
    const storage = getStorage();

    const [AllImagesSet, setAllImagesSet] = useState(false)
    const [allImages, setAllImages] = useState([])
    const [allImagesLinks, setAllImagesLinks] = useState([])
    const [allImagesLinksFilter, setAllImagesLinksFilter] = useState(allImagesLinks)

    const [render, setRender] = useState(0)

    const rerenderImages = () => {
        setAllImagesSet(false)
        setAllImages([])
        setAllImagesLinks([])
        setTimeout(() => {
            setRender(render + 1)
        }, 500);
  
    }
    useEffect(() => {
        if(AllImagesSet === false) {
          const listRef = ref(storage, `images`);
          listAll(listRef)
            .then((res) => {
              res.items.forEach((itemRef) => {
                allImages.push(itemRef)
              });
            })
            .finally(
              () => {
                setAllImagesSet(true)
              }
            )
            .catch((error) => {
              console.log(error)
            });
        }
      }, [render])
  
      useEffect(() => {
               allImages.forEach((e) => {
          const storageRef = ref(storage, `images/${e.name}`)
          getDownloadURL(storageRef)
            .then(url =>
              allImagesLinks.push(`${url}`)
            )
            .catch((error) => { console.log(error) })
        })
      }, [AllImagesSet])
    

    //   const [searchFilt, setSearchFilt] = useState("")
    
    //   useEffect(() => {
    //     const filteredLinks = allImagesLinks.filter(link => link.toUpperCase().includes(searchFilt.toUpperCase()));
    //     setAllImagesLinksFilter(filteredLinks);
    
    //   }, [allImagesLinks]);


    return (
        <StorageContext.Provider value={{
            allImagesLinks,
            rerenderImages,
            render
        }}>
            {children}

        </StorageContext.Provider>
    )

}

export default StorageContextProvider




